var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocdocument(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "68px",
    height: "67px",
    viewBox: "0 0 68 67",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Doc_Folder_ico") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 32 0 32 30 0 30"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Doc_Folder_ico",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.6450195,6 C25.2647779,6 10.9941068,6.5968015 10.9941068,6.5968015 C8.78822251,6.68358272 7,8.54334574 7,10.753784 L7,57.0001488 C7,59.2092056 8.7874392,61 11.0098757,61 L51.9901243,61 C54.2047175,61 56,59.2105871 56,57.0001488 L56,10.753784 C56,8.54472718 54.219457,6.67608841 52.0074159,6.58285378 C52.0074159,6.58285378 39.2619148,6 32.6450195,6 Z",
    id: "Rectangle-19",
    stroke: "#AFC0D3",
    fill: "#FFFFFF",
    transform: "translate(31.500000, 33.500000) rotate(-15.000000) translate(-31.500000, -33.500000) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8879743,11 C27.1645217,11 16.9999384,11.432254 16.9999384,11.432254 C14.7908334,11.5190645 13,13.3846787 13,15.5984197 L13,49.9910186 C13,52.2051179 14.7818508,54 16.9948438,54 L47.0051562,54 C49.2114475,54 51,52.2047597 51,49.9910186 L51,15.5984197 C51,13.3843205 49.2150488,11.5111655 46.9956574,11.4181566 C46.9956574,11.4181566 38.0194441,11 32.8879743,11 Z",
    id: "Rectangle-20",
    stroke: "#AFC0D3",
    fill: "#ECF1F7",
    opacity: 0.55,
    transform: "translate(32.000000, 32.500000) rotate(-15.000000) translate(-32.000000, -32.500000) "
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle-20-+-Rectangle-21",
    transform: "translate(5.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.5988741,5.5240024 C25.1395941,5.5240024 10.6675295,6.12105823 10.6675295,6.12105823 C8.46484145,6.20660295 6.67920998,8.07606348 6.67920998,10.2762654 L6.67920998,56.3789125 C6.67920998,58.5882253 8.47108065,60.3792272 10.6796199,60.3792272 L52.2035642,60.3792272 C54.4129296,60.3792272 56.2039741,58.5791144 56.2039741,56.3789125 L56.2039741,10.2762654 C56.2039741,8.06695257 54.4209206,6.19901275 52.2145647,6.10719878 C52.2145647,6.10719878 39.2866328,5.5240024 32.5988741,5.5240024 Z",
    id: "Rectangle-20",
    stroke: "#AFC0D3",
    fill: "#FFFFFF",
    transform: "translate(31.441592, 32.951615) rotate(-345.000000) translate(-31.441592, -32.951615) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2719965,11.0835883 C26.2841562,11.0835883 15.4584205,11.5333252 15.4584205,11.5333252 C13.2530934,11.6183107 11.4653225,13.4707087 11.4653225,15.6952142 L11.4653225,51.1098987 C11.4653225,53.3234611 13.2507604,55.1179079 15.4592412,55.1179079 L47.2267654,55.1179079 C49.4325458,55.1179079 51.2206841,53.3344042 51.2206841,51.1098987 L51.2206841,15.6952142 C51.2206841,13.4816518 49.4269089,11.6101434 47.232196,11.5198657 C47.232196,11.5198657 37.6405079,11.0835883 32.2719965,11.0835883 Z",
    id: "Rectangle-21",
    stroke: "#AFC0D3",
    fill: "#ECF1F7",
    opacity: 0.549965019,
    transform: "translate(31.343003, 33.100748) rotate(-345.000000) translate(-31.343003, -33.100748) "
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(30.000000, 36.000000) rotate(15.000000) translate(-30.000000, -36.000000) translate(14.000000, 21.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Duplicate-control"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-5",
    fill: "#D4DDE7",
    mask: "url(#mask-2)",
    x: 0,
    y: 0,
    width: 32,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-5",
    fill: "#D4DDE7",
    mask: "url(#mask-2)",
    x: 0,
    y: 6,
    width: 32,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-5",
    fill: "#D4DDE7",
    mask: "url(#mask-2)",
    x: 0,
    y: 12,
    width: 32,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-5",
    fill: "#D4DDE7",
    mask: "url(#mask-2)",
    x: 0,
    y: 18,
    width: 32,
    height: 1,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-5",
    fill: "#D4DDE7",
    mask: "url(#mask-2)",
    x: 0,
    y: 24,
    width: 32,
    height: 1,
    rx: 0.5
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-4",
    fill: "#4A90E2",
    x: 38,
    y: 8,
    width: 30,
    height: 11
  }), /*#__PURE__*/React.createElement("text", {
    id: "DOC",
    fontFamily: "Roboto-Bold, Roboto",
    fontSize: 10,
    fontWeight: "bold",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 43.0268555,
    y: 17
  }, "DOC")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocdocument);
export default __webpack_public_path__ + "static/media/docdocument.6a9abf3e98f71f10019eb17c0a9060de.svg";
export { ForwardRef as ReactComponent };